import { render, staticRenderFns } from "./VideosFilterForm.vue?vue&type=template&id=4710c5bb"
import script from "./VideosFilterForm.vue?vue&type=script&lang=ts"
export * from "./VideosFilterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports